module.exports = __webpack_public_path__ + "media/images/ic-seta-esquerda-8c6e7c29ef9db7766f41b6a842f5f528.svg";